import React, { useMemo, useState } from "react";
import "./LockScreen.css";
import logo from "./logo.png";

const STORAGE_KEY = "eastteam_app_session_v3";

// 8 accès magasin
const STORE_ACCOUNTS = [
  { login: "aaverviers", storeName: "Verviers", password: "affver4800" },
  { login: "aaeupen", storeName: "Eupen", password: "affeup4700" },
  { login: "aabouge", storeName: "Bouge", password: "affbou5004" },
  { login: "aanamur", storeName: "Namur", password: "affnam5000" },
  { login: "aamalmedy", storeName: "Malmedy", password: "affmal4960" },
  { login: "aaawans", storeName: "Awans", password: "affawa4340" },
  { login: "aarocourt", storeName: "Rocourt", password: "affroc4000" },
  { login: "aavise", storeName: "Vise", password: "affvis4600" },
  { login: "jonathan", storeName: "Jonathan", password: "joluno82" },
];

export default function LockScreen({ onUnlocked }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const canSubmit = useMemo(() => {
    return login.trim().length > 0 && password.trim().length > 0;
  }, [login, password]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    const normalizedLogin = login.trim().toLowerCase();

    const account = STORE_ACCOUNTS.find(
      (item) => item.login.toLowerCase() === normalizedLogin
    );

    if (!account) {
      setError("Login inconnu.");
      return;
    }

    if (password !== account.password) {
      setError("Mot de passe incorrect.");
      return;
    }

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        unlocked: true,
        login: account.login,
        storeName: account.storeName,
      })
    );

    onUnlocked({
      login: account.login,
      storeName: account.storeName,
    });
  };

  return (
    <div className="lockscreen">
      <div className="home-card glass-card">
        <div className="lockscreen-logo">
          <img src={logo} alt="iScan" />
        </div>

        <h1>Accès réservé</h1>
        <p>Veuillez entrer votre login magasin et le mot de passe.</p>

        <form onSubmit={handleSubmit}>

  <div className="login-field">
    <span className="login-icon">👤</span>
    <input
      type="text"
      placeholder="Login magasin"
      value={login}
      onChange={(e) => setLogin(e.target.value)}
      autoFocus
    />
  </div>

  <div className="login-field">
    <span className="login-icon">🔒</span>
    <input
      type="password"
      placeholder="Mot de passe"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />
  </div>

  {error && <div className="lockscreen-error">{error}</div>}

  <button type="submit" disabled={!canSubmit} className="login-button">
    Déverrouiller
  </button>

</form>

        <div className="lockscreen-hint">
          Astuce : l’accès reste mémorisé sur cette tablette.
        </div>
      </div>
    </div>
  );
}

export { STORAGE_KEY, STORE_ACCOUNTS };